import {ElementRef} from '@angular/core';

export function observePaneVisibilityClass(
  elementRef: ElementRef<HTMLElement>,
  document: Document,
  className: string
): MutationObserver | undefined {
  const host = elementRef?.nativeElement;
  const paneContainer = host?.closest('.backdrop-container') as HTMLElement;

  if (!paneContainer) {
    return undefined;
  }

  const updateVisibilityClass = () => {
    const isVisible = !paneContainer.hasAttribute('hidden');
    document?.body?.classList.toggle(className, isVisible);
  };

  updateVisibilityClass();

  const observer = new MutationObserver(updateVisibilityClass);
  observer.observe(paneContainer, {
    attributes: true,
    attributeFilter: ['hidden']
  });

  return observer;
}

export function clearPaneVisibilityClass(
  document: Document,
  className: string,
  observer?: MutationObserver
): void {
  observer?.disconnect();
  document?.body?.classList.remove(className);
}